module.exports = __webpack_public_path__ + "40035d80cd94db67c1334e73466a2b14.png";